import React from 'react';
import Header from './Header';
import Footer from './Footer';

const EnergyDrinkAndSachets = () => {
    const rawHtml = `
        <style>
            .form-control::placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control:-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control::-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .accordion-item {
                border: 1px solid rgba(0,0,0,.125);
                margin-bottom: 1rem;
                border-radius: 0.5rem !important;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0,0,0,.05);
                transition: all 0.3s ease;
            }
            .accordion-item:hover {
                box-shadow: 0 4px 8px rgba(0,0,0,.1);
                transform: translateY(-2px);
            }
            .accordion-button {
                padding: 1.25rem;
                font-weight: 600;
                font-size: 1.1rem;
                color: #333;
                background-color: #f8f9fa;
                border: none;
                position: relative;
            }
            .accordion-button:not(.collapsed) {
                color: #fff;
                background-color: var(--cnvs-themecolor, #2E3192);
                box-shadow: none;
            }
            .accordion-button:not(.collapsed)::after {
                filter: brightness(0) invert(1);
            }
            .accordion-button:focus {
                box-shadow: none;
                border-color: rgba(0,0,0,.125);
            }
            .accordion-body {
                padding: 1.5rem;
                background-color: #fff;
            }
            .table {
                margin-bottom: 0;
            }
            .table thead th {
                background-color: #f8f9fa;
                border-bottom: 2px solid #dee2e6;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.5px;
            }
            .table tbody td {
                vertical-align: middle;
                font-size: 0.95rem;
            }
            .table tbody tr:hover {
                background-color: rgba(0,0,0,.02);
            }
            .table td, .table th {
                word-break: break-word;
                white-space: normal;
                vertical-align: top;
            }
            .table ul {
                padding-left: 1.2em;
                margin-bottom: 0;
            }
            .table li {
                word-break: break-word;
                white-space: normal;
            }
        </style>

        <div id="wrapper">
            <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                <div class="container mt-lg-6">
                    <div class="row justify-content-between align-items-center py-lg-6 py-5">
                        <div class="col-lg-5 mb-4 mb-lg-0">
                            <img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="50">
                            <h2 class="display-3 fw-bold color all-ts">Energy Drink & Sachets / Sticks</h2>
                            <p>Explore our range of instant energy drinks, sachets, and stick supplements for quick nutrition and hydration</p>
                        </div>
                        <div class="col-lg-6">
                            <div class="row align-items-center g-4">
                                <div class="col-6">
                                    <img src="https://i.pinimg.com/736x/2a/0a/0c/2a0a0c1e9f2df4591d14645aa2b39a28.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                                <div class="col-6">
                                    <img src="demos/doctors/images/hero/r2.jpg" alt="Image" class="object-cover rounded-6 mb-4">
                                    <img src="demos/doctors/images/hero/r3.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="content">
                <div class="content-wrap py-0">
                    <div id="products" class="section bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Energy Drink & Sachets / Sticks</h2>
                                    <p>Comprehensive range of instant energy, hydration, and supplement sachets for all needs</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="accordion">
                                        <!-- ENERGY DRINK AND SACHET / STICKS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#energyDrinkSachets">
                                                    <i class="bi bi-capsule me-2"></i>ENERGY DRINK AND SACHET / STICKS
                                                </button>
                                            </h2>
                                            <div id="energyDrinkSachets" class="accordion-collapse collapse show">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Instant Energy Drink Powder</td>
                                                                    <td>Quickly replenishes energy and electrolytes for instant refreshment.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Instant Drink Mix Powder</td>
                                                                    <td>Convenient, flavorful drink mix for hydration and energy.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>L-Glutamine Powder</td>
                                                                    <td>Supports muscle recovery and immune function.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>L-Arginine with Lycopene, Proanthocyanidin, Vitamins & Zinc Granules Sachets</td>
                                                                    <td>Formulated for cardiovascular health and antioxidant support.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>L-Arginine with Grape Seed Extract, DHA, Vitamin B6, Folic Acid Granules Sachets</td>
                                                                    <td>Supports heart, brain, and vascular health.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Coral Calcium Sachets</td>
                                                                    <td>Natural calcium source for bone and dental health.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Glucosamine + MSM + Chondroitin Sulphate Sachets</td>
                                                                    <td>Joint health formula for mobility and flexibility.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Pre and Pro-Biotic Capsules with Zinc Sachets</td>
                                                                    <td>Gut health and immunity support in convenient sachet form.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Electrolyte Hydration Powder</td>
                                                                    <td>Replenishes lost electrolytes and supports hydration during activity.</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default EnergyDrinkAndSachets;
